import { getWrapperClassName, IconProps } from '@/components/design-system/utils'
import React from 'react'

export const TLIconCalendarNoDate = (props: IconProps) => {
  const height = `${ props.height }px`
  const width = `${ props.width }px`
  return (
      <svg
          className={ getWrapperClassName(props.className, '') }
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          height={ height }
          width={ width }>
        { props.tooltip && <title>{ props.tooltip }</title> }
        <g fill="none" id="calendar-no" stroke="none">
          <path
              d="M2.39794316,5.81266974 L4.11671179,7.53074655 C4.05954456,7.63813009 4.0213866,7.7571708 4.00672773,7.88337887 L4,8 L4,10 L6.586,10 L11,14.415 L11,15 L11.585,15 L18.585,22 L4.5638852,22 C3.67236646,22 3.34908022,21.9071744 3.0231543,21.7328673 C2.69722837,21.5585602 2.4414398,21.3027716 2.2671327,20.9768457 C2.10623385,20.675991 2.014763,20.3773855 2.00164263,19.6320228 L2,7.5638852 C2,6.67236646 2.09282561,6.34908022 2.2671327,6.0231543 C2.30660224,5.94935268 2.35024963,5.87914726 2.39794316,5.81266974 Z M20.2928932,21.7071068 L2.29289322,3.70710678 L3.70710678,2.29289322 L6,4.585 L6,2 L8,2 L8,5 L16,5 L16,2 L18,2 L18,5 L19.4361148,5 C20.3276335,5 20.6509198,5.09282561 20.9768457,5.2671327 C21.3027716,5.4414398 21.5585602,5.69722837 21.7328673,6.0231543 C21.9071744,6.34908022 22,6.67236646 22,7.5638852 L22,19.4361148 C22,20.3276335 21.9071744,20.6509198 21.7328673,20.9768457 C21.5585602,21.3027716 21.3027716,21.5585602 20.9768457,21.7328673 C20.7346058,21.8624186 20.4938241,21.9469596 20.0201212,21.9818327 L20.7071068,21.2928932 L20.2928932,21.7071068 Z M13,17 L11,17 L11,19 L13,19 L13,17 Z M8,17 L6,17 L6,19 L8,19 L8,17 Z M8,13 L6,13 L6,15 L8,15 L8,13 Z M18,13 L16,13 L16,14.585 L16.415,15 L18,15 L18,13 Z M11.415,10 L20,10 L20,8 C20,7.44771525 19.5522847,7 19,7 L8.415,7 L11.415,10 Z"
              fill="currentColor"/>
        </g>
      </svg>
  )
}

TLIconCalendarNoDate.defaultProps = {
  className: '',
  height: 24,
  width: 24,
  tooltip: null
}
